<template>
  <div class="linexo-site-connect-additional-content-outro">
    <h2 v-if="headline" class="linexo-site-connect-additional-content-outro__headline">
      {{ headline }}
    </h2>
    <img
      v-if="image"
      class="linexo-site-connect-additional-content-outro__image"
      :src="image"
      alt=""
      aria-hidden="true"
    />
    <div v-if="text" class="linexo-site-connect-additional-content-outro__text">{{ text }}</div>
  </div>
</template>
<script lang="ts" setup>
type SiteConnectAdditionalContentOutroProps = {
  text?: string
  image?: string
  headline?: string
}

defineProps<SiteConnectAdditionalContentOutroProps>()
</script>
<style lang="scss" scoped>
@import './site-connect-additional-content-outro.scss';
</style>
